module.exports = __webpack_public_path__ + "img/c_slider_crm.5ee04a66.jpg";